import { Injectable } from '@angular/core'
import { IDataConverter } from '@adex/shared/models/data-converter'
import { INotificationChannelManyDto } from '@adex/shared/models/dto/notification.dto'
import { NotificationType } from '@adex/shared/models/inside-models/notification'
import { NotificationConverter } from './notification.converter'


@Injectable({
  providedIn: 'any'
})
export class NotificationListConverter implements IDataConverter<INotificationChannelManyDto, NotificationType[]> {

  constructor(private readonly notificationConverter: NotificationConverter) {
  }


  public toInside(data: INotificationChannelManyDto): NotificationType[] {
    return data.channels.map(channel => this.notificationConverter.toInside({ channel }))
  }

  public toOutside(data: NotificationType[]): INotificationChannelManyDto {
    return undefined
  }

}
